module.exports = ".notification{display:block;color:#aeaeae !important;clear:both;cursor:pointer;padding:10px 15px}.notification::after{content:'';display:block;width:100%;margin-top:5px;border-bottom:1px solid #404040}.notification .notification-text{padding-top:10px;padding-bottom:10px;font-size:13px}.notification .icon{width:18px;font-size:18px;color:#9e9e9e}.notification .footer{color:#9e9e9e}.notification .timestamp{color:#737373;font-size:11px}h3{color:#555}a *{font-weight:bold}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notifications/notifications.component.scss
// module id = 648
// module chunks = 0